<template>
    <transition name="grow" appear>
        <div class="notifications-badge" v-if="count">
            <div class="the-badge" :class="{small, muted}">
                <div class="label">{{ count }}</div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'NotificationsBadge',
    props: {
        counter: { default: 0 },
        small: Boolean,
        muted: Boolean
    },
    computed: {
        count(){
            let count = parseInt(this.counter)
            if(isNaN(count)){
                return 0
            }
            if(count>99){
                return 99
            }
            return count
        }
    }
}
</script>

<style lang="css" scoped>
.notifications-badge {
   margin-left: 10px;
}
.the-badge {
    width: 24px;
    height: 24px;
    text-align: center;
    background-color: #E77423;
    border-radius: 50%;
    box-shadow: 0 1px 1px rgba(0,0,0,0.25);
    transition: all 0.15s ease;
}
.label {
    font-weight: bold;
    color: #F7F9F9;
    font-size: 14px;
    line-height: 24px;
}

.the-badge.small {
    width: 16px;
    height: 16px;
}
.small .label {
    font-size: 9px;
    line-height: 16px;
}

.grow-enter-active, .grow-leave-active {
  transition: transform .25s, opacity 0.18s;
}
.grow-enter-from, .grow-leave-to {
    transform: scale(0) translate(-20px, 20px);
    opacity: 0;
}
.muted.the-badge {
    background-color: #435152;
}
</style>